/* eslint-disable max-len */
import { PIcon } from '@porsche-design-system/components-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import breakpoints from '../../../utilities/breakpoints';
import { type AddVehicleButtonProps } from '../../context';

const AddVehicle = styled.button`
    width: 100%;
    height: var(--current-single-image-height, auto);
    max-height: var(--calculator-comparison-vehicle-image-height);
    @media (max-width: ${breakpoints.xxl}) {
        max-height: var(--calculator-comparison-vehicle-image-height-xl);
    }
    @media (max-width: ${breakpoints.xl}) {
        max-height: var(--calculator-comparison-vehicle-image-height-lg);
    }
    @media (max-width: ${breakpoints.lg}) {
        max-height: var(--calculator-comparison-vehicle-image-height-m);
    }
    @media (max-width: ${breakpoints.md}) {
        max-height: var(--calculator-comparison-vehicle-image-height-sm);
    }
    aspect-ratio: 16/9;
    border-radius: var(--vehicle-image-border-radius);
    background-color: #eff0f1;
    color: var(--ant-primary-color);

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 18px;

    border: none;

    &:hover {
        cursor: pointer;
    }

    margin-bottom: 1rem;

    @media (max-width: ${breakpoints.sm}) {
        height: 3rem;
    }
`;

const AddVehicleText = styled.span`
    padding-left: 4px;
`;

const AddVehicleButton = ({ onClick }: AddVehicleButtonProps) => {
    const { t } = useTranslation(['comparison']);

    return (
        <AddVehicle onClick={onClick} type="button">
            <PIcon aria={{ 'aria-label': 'Add icon' }} name="add" />
            <AddVehicleText>{t('comparison:action.addVehicle')}</AddVehicleText>
        </AddVehicle>
    );
};

export default AddVehicleButton;
